// Google Sheets Integration (Legacy - now using Make.com)
// This file is kept for backward compatibility with existing contact forms

export interface FormSubmission {
  name: string
  phone: string
  email: string
  message?: string
  type: string
  source?: string
  timestamp?: string
  orderNumber?: string
  whatsappGroup?: string
  ticketType?: string
  price?: string
  gender?: string
  roomType?: string
  roommate1?: string
  roommate2?: string
  competitiveTrack?: string
  rowingType?: string
  clubName?: string
  rentBoard?: string
}

export async function sendToGoogleSheets(
  data: FormSubmission,
): Promise<boolean> {
  // This function is deprecated for Water Tribe Fest registrations
  // Water Tribe Fest now uses Make.com webhook (see utils/makeWebhook.ts)
  // This is kept only for other contact forms on the site

  console.warn(
    '⚠️ sendToGoogleSheets is deprecated for festival registrations. Use Make.com webhook instead.',
  )

  return true
}

export async function submitForm(data: FormSubmission): Promise<{
  success: boolean
  message: string
}> {
  // For Water Tribe Fest registrations, data is stored in localStorage
  // and sent to Make.com webhook after successful payment
  // See: TranzilaSuccessPage.tsx and utils/makeWebhook.ts

  console.log('📝 Form data prepared for payment flow')

  return {
    success: true,
    message: 'נתונים נשמרו בהצלחה',
  }
}
